import React, { Component } from "react";
import AccountHoldings from '../components/AccountHoldings';

class HoldingsDashboard extends Component {

  constructor(props) {
    super(props);

    this.state = {

    }

  }


  render() {
    return(
        <div className='holdingsDash'>
            <AccountHoldings user={this.props.user} compSettings={this.props.compSettings} styleSettings={this.props.styleSettings} portfolio={this.props.portfolio} household={this.props.user.defaultAcct.household} idToken={this.props.idToken} />
        </div>
    );
  }

}

export default HoldingsDashboard;